import React from 'react'
import { cn } from 'oddle-shop-monorepo.design-system'

const ProgressBar = ({
  percent: _percent,
  fill,
  background,
}: {
  percent: number
  fill?: string
  background?: string
}) => {
  const percent = Math.min(_percent, 100)
  return (
    <div
      className={cn(
        'relative h-1.5 w-full rounded-full',
        background ? background : 'bg-[#D6D6D6]'
      )}
    >
      <div
        className={cn('absolute left-0 top-0 h-1.5 rounded-full')}
        style={{
          width: `${percent}%`,
          backgroundColor:
            fill || Math.round(percent) === 100 ? '#067E30' : '#FFCF35',
        }}
      />
    </div>
  )
}

export default ProgressBar
